<script>
import {
  DigitalProductCardElementMixin,
} from "%/dynamic-component-editor/standard-components/digital-product-card/digital-product-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "DigitalProductDescription",
  elementPanelSettings: {
    displayName: "Description",
    displayIcon: "text",
    elementGroup: "digitalProductElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [DigitalProductCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.description;
    },
  },
};
</script>
